import styled from 'styled-components';

export const Pagina = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`;

export const Painel = styled.section`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 16px 18px;
`;

export const CampoTermo = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;

  .ant-input,
  .ant-input-affix-wrapper {
    border-radius: 8px;
  }
`;

export const Filtros = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;

  .ant-picker {
    border-radius: 8px;
  }

  .ant-radio-button-wrapper:first-child {
    border-radius: 8px 0 0 8px;
  }

  .ant-radio-button-wrapper:last-child {
    border-radius: 0 8px 8px 0;
  }
`;

export const Campo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 180px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
`;

export const Rotulo = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const Periodo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const SelectAncora = styled.div`
  position: relative;
  width: 343px;

  @media (max-width: 575px) {
    width: 100%;
  }
`;

export const Acoes = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto;
`;

export const Contagem = styled.div`
  color: rgba(0, 0, 0, 0.65);
  font-weight: 600;
`;

export const Lista = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Cartao = styled.div`
  border: 1px solid #e6e8eb;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;

  .ant-collapse {
    background: #fff;
    border: none;
  }

  .ant-collapse-item {
    border: none !important;
  }

  .ant-collapse-header {
    display: flex !important;
    align-items: center !important;
    flex-wrap: nowrap !important;
    background: #fff !important;
    padding: 12px 16px !important;
  }

  .ant-collapse-arrow {
    position: static !important;
    transform: none !important;
    margin-right: 12px;
    line-height: 0;
  }

  .ant-collapse-header > :not(.ant-collapse-extra):not(.ant-collapse-arrow) {
    flex: 1 1 auto;
    min-width: 0;
  }

  .ant-collapse-extra {
    float: none !important;
    display: flex !important;
    align-items: center;
    flex: 0 0 auto;
    margin-left: auto !important;
  }
`;

export const Cabecalho = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const Selo = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: #fde8e8;
  color: #a8071a;
  font-size: 11px;
  font-weight: 700;
  flex: 0 0 44px;
`;

export const Textos = styled.div`
  min-width: 0;
`;

export const Nome = styled.div`
  color: #1f2933;
  font-weight: 600;
`;

export const Linha = styled.div`
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
`;

export const AcoesItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Acao = styled.button`
  display: inline-flex;
  border: none;
  background: transparent;
  color: rgba(0, 0, 0, 0.45);
  font-size: 18px;
  cursor: pointer;
`;

export const AcaoDownload = styled.button`
  display: inline-flex;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.corTema} !important;
  font-size: 22px;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.corTema} !important;
  }
`;

export const Fichas = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;

export const Ficha = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px;
`;

export const FichaTitulo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.corTema};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const NomeArquivo = styled.div`
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;

  span {
    display: block;
    margin-top: 4px;
    overflow: hidden;
    color: #1f2933;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const Vazio = styled.p`
  margin: 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
`;

export const Dado = styled.div`
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;

  & + & {
    margin-top: 12px;
  }

  strong {
    display: block;
    margin-top: 4px;
    color: #1f2933;
    font-size: 14px;
    font-weight: 600;
    word-break: break-word;
  }
`;

export const Par = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;

  ${Dado} + ${Dado} {
    margin-top: 0;
  }
`;

export const Paginacao = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Tamanho = styled.div`
  position: relative;
  width: 110px;
`;
